import { Flex, Spinner, Stack, Text, BoxProps } from "@chakra-ui/react";
import { memo } from "react";
import { DATE_TIME_SLASH_FORMAT, formatDate } from "utils/date";
import { ImageValue } from "..";
import ImageActions from "./ImageActions";
import Image from "components/Image";

export interface ImageProps extends ImageValue {
  boxProps?: BoxProps;
}

interface Props {
  isLoading?: boolean;
  isDisabled?: boolean;
  imageProps: ImageProps;

  onOpenCamera: () => void;
  onSelectFile: (file: File) => void;
  onOpenPhotoHistories: () => void;
}

const ImageContainer = (props: Props) => {
  const {
    isLoading,
    isDisabled,
    imageProps,
    onOpenCamera,
    onSelectFile,
    onOpenPhotoHistories,
  } = props;

  return (
    <Flex gap="0.8rem" justifyContent="space-between">
      <Stack
        borderRadius="4px"
        gap="0.8rem"
        bg="#fff"
        p="1.2rem"
        border="1px solid #D4D4D4"
        flex={1}
        maxWidth="25.6rem"
        minWidth="25.6rem"
      >
        <Flex
          position="relative"
          width="100%"
          className="capture-group"
          maxHeight="16rem"
          maxWidth="23.2rem"
          justifyContent="center"
        >
          <Image
            width="100%"
            height={"100%"}
            src={imageProps?.src}
            objectFit="contain"
            {...imageProps.boxProps}
          />
          {isLoading && (
            <Flex
              position={"absolute"}
              top={0}
              left={0}
              w="100%"
              h="100%"
              alignItems={"center"}
              justifyContent={"center"}
              bg="rgba(0,0,0,.2)"
              backdropFilter={"blur(5px)"}
            >
              <Spinner />
            </Flex>
          )}
        </Flex>
        <Text color="#737373" textAlign="left" fontSize="1.4rem">
          {formatDate(imageProps?.lastModifiedDateFile, DATE_TIME_SLASH_FORMAT)}
        </Text>
      </Stack>

      <ImageActions
        isDisabled={isDisabled}
        onOpenCamera={onOpenCamera}
        onSelectFile={onSelectFile}
        onOpenPhotoHistories={onOpenPhotoHistories}
      />
    </Flex>
  );
};

export default memo(ImageContainer);
